import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import usePortalService from '../services/PortalService';
import { useNavigate } from 'react-router-dom';
import { Company } from '../types';
import useRole from '../hooks/useRole';
import { UserRole } from '../Enums/UserRole';
import { RegistrationIsRequired } from './Modals';

type EmployerCardProps = {
    company: Company,
    address?: string
}
 
const EmployerCard = ({ company, address = company?.address } : EmployerCardProps) => {
    const navigate = useNavigate();
    const {getCompanyImage, reactToCompany} = usePortalService();
    const { role } = useRole();

    const [logo, setLogo] = useState('');
    const [link, setLink] = useState('');
    const [isModalRegistrationRequiredOpen, setIsModalRegistrationRequiredOpen] = useState(false);

    useEffect(() => {
        if (!company) return
        if (company.logoId) {
            getCompanyImage(company.logoId)  
            .then(result => {
                setLogo(result)
            })
        }
        if (typeof company.link === 'string') {
            if (company.link.includes("http")) {
                setLink(company.link)
            } else {
                setLink("https://"+company.link)
            }
        }
    }, [company])

    const companyHandle = () => {
        navigate("/company/"+company.id);
    }
    
  
    const showModalRegistrationRequired = () => {
        setIsModalRegistrationRequiredOpen(true);
    }
  
    const closeModalRegistrationRequiredHandler = () => {
        setIsModalRegistrationRequiredOpen(false);
    }

    const wantToWorkHereHandle = () => {
        if (role === UserRole.Student) {
            reactToCompany({
                companyId : company.id
            }).then(res => {
                console.log(res);
            });
            // Тут лучше показать модальное окно
        }
        else if (role === UserRole.NotAuthorized) {
            showModalRegistrationRequired();
        }
    }

    return (
        <div className="employer-card">
            <div className="different-edges-container" style={{marginBottom: '24px'}} onClick={companyHandle}>
                <div className="left-edge">
                    <h1 style={{ marginBottom: '8px' }}> {company?.name} </h1>
                    <h2 className="address" style={{ marginBottom: '8px' }}> {address}  </h2>
                    <a href={link} className="gray-link" target="_blank" rel='noreferrer'> {company?.link} </a>
                </div>
                <div className="right-edge">
                    {(logo) && <img src={logo} className="logo-company-card" alt=""/>}
                </div>
            </div>
            <Button type="link" style={{padding:'0px 0px'}} onClick={wantToWorkHereHandle}> Хочу здесь работать </Button>
            <RegistrationIsRequired  isOpen={isModalRegistrationRequiredOpen} close={closeModalRegistrationRequiredHandler}/>
        </div>
    )
}

export default EmployerCard;